const fa = {
  empty_list: 'موردی یافت نشد.',
  category_name: 'موضوع: {{categoryName}}',
  exit: 'خروج',
  empty_user_hint_1: 'به جهت تسهیل و تمرکز پرسش و پاسخ، لطفا درخواست خود را فقط در این سامانه ایجاد نمایید. برای ایجاد اولین درخواست،',
  here: 'اینجا',
  empty_user_hint_2: 'را کلیک کنید.',
  create_new_ticket: '+ درخواست جدید',
  status: 'وضعیت:',
  all: 'همه',
  next: 'مرحله بعد',
  creating_new_ticket: 'ایجاد درخواست جدید',
  new_ticket_help: 'موضوع درخواست خود را به دقت انتخاب کنید، سپس درخواست خود را در یک  پیام حداکثر سه دقیقه‌‌ای بیان  کنید.',
  search_user: 'جستجوی کاربر',
  help: 'راهنمای استفاده',
  name: 'نام',
  last_name: 'نام خانوادگی',
}

export default fa
